import React, {useState, useEffect} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import {textTruncateByLength} from 'utils/other';
import {toast} from 'react-toastify';
import {assignMultipleAlertsToUser} from 'utils/api/usersApi';
import DualSelect from 'components/DualSelect';
import SpinnerButton from 'components/SpinnerButton';
// import DualListBox from 'components/DualListBox/index';
//import './style.scss';


const AssignSavedSearchModal = (props) => {
    const {user, alertType, isOpen, toggle, selectedList, fullList, refreshList} = props;
    const [selectedSavedSearches, setSelectedSavedSearches] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        setSelectedSavedSearches(selectedList);
    }, []);

    const handleSubmit = async() => {
        try {
            setSubmitting(true);
            let selectedSearchIds = selectedSavedSearches.map(item => item.id);
            await assignMultipleAlertsToUser(user.id, selectedSearchIds, alertType);
            refreshList(true);
            toast.success('Alert successfully assigned');
            setSubmitting(false);
            toggle();
        } catch(err) {
            setSubmitting(false);
            console.log(err);
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            }
            console.log(err);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="feeds-select-modal" style={{width: '80%', maxWidth: 'none'}}>
            <ModalHeader toggle={toggle}>
                <strong>{alertType === 'daily' ? 'Assign Daily Alert' : 'Assign Real Time Alert'}</strong>
            </ModalHeader>
            <ModalBody>
                <div>User Name: {textTruncateByLength(user.name, 50)}</div>
                <div style={{fontSize: '17.5px', fontWeight: '700', margin: '10px 0'}}>Select Saved Searches</div>
                <DualSelect
                    selectedList={selectedSavedSearches}
                    fullList={fullList}
                    // groups={userGroups}
                    showAssignAll
                    onSelect={setSelectedSavedSearches}
                    contentType="savedSearches"
                    largeBoxes
                />
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{color: 'white'}} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    style={{minWidth: '80px', marginLeft: '10px'}}
                    // disabled={searchValue.length > 990}
                    onClick={handleSubmit}
                    className="btn calltoaction-button"
                    submitting={submitting}
                    title="Assign"
                />
            </ModalFooter>
        </Modal>
    );
};

export default AssignSavedSearchModal;
